import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useInviteLink } from '@sorare/core/src/hooks/useInviteLink';
import { getSportFromSportOrShared } from '@sorare/core/src/lib/sports';

import { DumbNotification } from 'components/activity/DumbNotification';

import { commonNotificationInterfaceFragment } from '../fragments';
import type { CommonNotificationProps } from '../types';
import type { ReferralRewardNotification_referralRewardNotification } from './__generated__/index.graphql';

type Props = CommonNotificationProps & {
  notification: ReferralRewardNotification_referralRewardNotification;
};

export const ReferralRewardNotification = ({
  notification,
  ...rest
}: Props) => {
  const { currentUser } = useCurrentUserContext();
  const { name, createdAt, sport, read } = notification;
  const inviteLink = useInviteLink(
    getSportFromSportOrShared(sport) || undefined
  );

  return (
    <DumbNotification
      name={name}
      title={<LazyMarkdown data={notification.markdownBody} />}
      userAvatar={currentUser}
      link={inviteLink}
      createdAt={createdAt}
      sport={sport}
      read={read}
      {...rest}
    />
  );
};

ReferralRewardNotification.fragments = {
  referralRewardNotification: gql`
    fragment ReferralRewardNotification_referralRewardNotification on ReferralRewardNotification {
      id
      sport
      createdAt
      name
      read
      ...Notification_notificationInterface
    }
    ${commonNotificationInterfaceFragment}
  ` as TypedDocumentNode<ReferralRewardNotification_referralRewardNotification>,
};
